import React from "react";
import { Box } from '@mui/material';
import Header from "./Header.js";
import ProgressCards from "./ProgressCards.js";
import CompaniesOverview from "./CompaniesOverview.js";
import RequestsStatusPie from "./RequestsStatusPie.js";
import CircularChartComponent from './CircularChartComponent';
import BarChartComponent from './BarChartComponent';
import WeeklyStatusChart from './WeeklyStatusChart.js';
import YearlyOverviewChart from './YearlyOverviewChart.js';
import RevenueOverview from "./RevenueOverview.js";
import RevenueGenerated from './RevenueGenerated';
import RevenueChart from "./RevenueChart.js";
import RevenureForcastTable from './RevenueForcastTable.js';
import "./style.css";
import RevenueForecastChart from "./RevenueForcast.js";
import RequestStatusChart from "./RequestStatusChartFile.js";

const Dashboard = () => {
  return (
    <Box 
      className="dashboard-file"
      sx={{
        backgroundColor: '#f5f5f5',
        minHeight: '100vh',
        p: { xs: 1, sm: 2, md: 4, lg: 6 }, // Responsive padding
      }}
    >
      {/* Header */}
      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <Header />
      </Box>

      {/* Progress Cards */}
      <Box sx={{ mb: { xs: 3, md: 4 } }}>
        <ProgressCards />
      </Box>

      {/* Companies Overview */}
      <Box sx={{ mb: { xs: 3, md: 4 } }}>
        <Box 
          className="row"
          sx={{
            mx: { xs: 0, md: -1 }, // Adjust negative margins for mobile
          }}
        >
          <Box 
            className="mb-6"
            sx={{
              px: { xs: 0, md: 1 }, // Responsive padding for grid items
            }}
          >
            <CompaniesOverview />
          </Box>
        </Box>
      </Box>

      {/* Charts Section */}
      <Box sx={{ mb: { xs: 3, md: 4 } }}>
        {/* Circular Chart */}
        <Box 
          className="row mt-4"
          sx={{
            mx: { xs: 0, md: -1 },
            mt: { xs: 2, md: 4 },
          }}
        >
          <Box sx={{ px: { xs: 0, md: 1 } }}>
            <CircularChartComponent />
          </Box>
        </Box>

        {/* Request Status Chart */}
        <Box 
          className="row mt-4"
          sx={{
            mx: { xs: 0, md: -1 },
            mt: { xs: 2, md: 4 },
          }}
        >
          <Box sx={{ px: { xs: 0, md: 1 } }}>
            <RequestStatusChart />
          </Box>
        </Box>
      </Box>

      {/* Shadow Custom Section */}
      <Box 
        className="shadow-custom card-hover transition-custom"
        sx={{
          p: { xs: 1, md: 2 }, // Responsive padding for shadow container
          borderRadius: { xs: 1, md: 2 }, // Responsive border radius
        }}
      >
        {/* Commented content preserved for future use */}
        {/* <div className="mt-4">
          <WeeklyStatusChart />
        </div> */}
      </Box>

      {/* Commented sections preserved for future use */}
      {/* 
      <Box 
        className="row mt-4"
        sx={{
          mx: { xs: 0, md: -1 },
          mt: { xs: 2, md: 4 },
        }}
      >
        <YearlyOverviewChart />
      </Box>

      <Box 
        className="row mt-4"
        sx={{
          mx: { xs: 0, md: -1 },
          mt: { xs: 2, md: 4 },
        }}
      >
        <Box 
          className="col-lg-6"
          sx={{
            px: { xs: 0, sm: 1 },
            mb: { xs: 2, lg: 0 },
          }}
        >
          <RevenueOverview />
        </Box>
        <Box 
          className="col-lg-6"
          sx={{
            px: { xs: 0, sm: 1 },
          }}
        >
          <RevenueGenerated />
        </Box>
      </Box>

      <Box 
        className="row"
        sx={{
          mx: { xs: 0, md: -1 },
        }}
      >
        <RevenueChart />
      </Box>

      <Box 
        className="row"
        sx={{
          mx: { xs: 0, md: -1 },
        }}
      >
        <RevenueForecastChart />
      </Box>

      <Box 
        className="row"
        sx={{
          mx: { xs: 0, md: -1 },
        }}
      >
        <RevenureForcastTable />
      </Box>
      */}
    </Box>
  );
};

export default Dashboard;